import useCoreModelsFind from 'hooks/useCoreModelsFind'

export default (scheduleShiftId, opts) => useCoreModelsFind('scheduleShift', scheduleShiftId, opts)
